<template>
  <div class="leaderboard">
    <div class="myTit">我的当前排名:</div>
    <div class="myLi">
      <div class="num fl">
        <span>{{my.points}}</span>
      </div>
      <div class="img fl"><img :src="my.avatar" width="70" height="70" alt=""></div>
      <div class="txt fl">
        <p>{{my.username}}</p>
        <p>{{my.name}}</p>
      </div>
      <div class="points fr">{{my.points}}分</div>
    </div>

    <div class="ul">
      <li v-for="(item,index) in list.list" :key="index">
        <div class="num fl">
          <img v-if="index === 0" src="./1.png" width="35" height="30" alt="">
          <img v-if="index === 1" src="./2.png" width="35" height="30" alt="">
          <img v-if="index === 2" src="./3.png" width="35" height="30" alt="">
          <span v-if="index !== 0 && index !== 1 && index !== 2">{{index+1}}</span>
        </div>
        <div class="img fl"><img :src="item.avatar" width="70" height="70" alt=""></div>
        <div class="txt fl">
          <p>{{item.username}}</p>
          <p>{{item.name}}</p>
        </div>
        <div class="points fr">{{item.points}}分</div>
      </li>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        list: {},
        my: {}
      }
    },
    created () {
      this.getpointsrank()
    },
    methods: {
      getpointsrank () {
        this.$http.post('/apipx/Personal/pointsrank', {
          p: this.page,
          row: 10,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.list = res.data
            this.my = res.data.my
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .leaderboard {
    .myTit {
      color: #8b8b8b;
      font-size: 16px;
    }

    .myLi {
      height: 70px;
      padding: 35px;
      box-shadow: 0px 0px 20px #e2e0e0;
      border-radius: 35px;
      margin: 20px auto;

      .num {
        width: 80px;
        height: 70px;
        line-height: 70px;
        font-style: italic;
        color: #969696;
        position: relative;

        span {
          text-indent: 10px;
        }

        img {
          position: absolute;
          left: 0;
          top: 50%;
          margin: -15px 0 0 0;
        }
      }

      .img {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        overflow: hidden;
      }

      .txt {
        width: 300px;
        height: 70px;
        margin: 0 0 0 20px;

        p:first-child {
          font-size: 16px;
          margin: 15px 0 0 0;
        }

        p:last-child {
          color: #a4a4a4;
          margin: 5px 0 0 0;
        }
      }

      .points {
        font-size: 20px;
        color: #ff827b;
        line-height: 70px;
      }
    }

    .ul {
      margin: 20px auto;
      box-shadow: 0px 0px 20px #e2e0e0;
      border-radius: 35px;
      overflow: hidden;
      padding: 35px;

      li {
        height: 70px;
        padding: 35px 0;
        border-bottom: 1px solid #ebebeb;

        .num {
          width: 80px;
          height: 70px;
          line-height: 70px;
          font-style: italic;
          color: #969696;
          position: relative;

          span {
            padding-left: 10px;
          }

          img {
            position: absolute;
            left: 0;
            top: 50%;
            margin: -15px 0 0 0;
          }
        }

        .img {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          overflow: hidden;
        }

        .txt {
          width: 300px;
          height: 70px;
          margin: 0 0 0 20px;

          p:first-child {
            font-size: 16px;
            margin: 15px 0 0 0;
          }

          p:last-child {
            color: #a4a4a4;
            margin: 5px 0 0 0;
          }
        }

        .points {
          font-size: 20px;
          color: #ff827b;
          line-height: 70px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/userInfo/integral/leaderboard/leaderboard.vue